export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9842.576d1921.jpg";